<template>
    <router-link
        :to="href"
        class="flex group space-x-4 font-semibold h-12 px-4 items-center rounded-md text-app-font-grey-500 dark:text-app-font-grey-dark-500 hover:text-brand-500 dark:hover:text-brand-500 focus:text-brand-500 dark:focus:text-brand-500 hover:bg-brand-500 active:bg-opacity-40 hover:bg-opacity-25 focus:outline-none focus-visible:ring-2 focus-visible:outline-none focus-visible:ring-brand-200 transition-colors duration-300 ease-in-out"
    >
        <span
            v-if="isIcon"
            class="text-app-font-light-grey-500 dark:text-app-font-light-grey-dark-500 group-hover:text-brand-500 transition-colors duration-300 ease-in-out"
        >
            <icon-base size="24" :name="icon" title="" />
        </span>
        <span>
            {{ name }}
        </span>
    </router-link>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import IconBase from '@/common/components/ui/icons/IconBase.vue'

export default defineComponent({
    name: 'SidebarBaseButton',
    components: {
        IconBase,
    },
    props: {
        href: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const isIcon = computed(() => {
            if (props.icon) {
                return true
            }
            return false
        })

        return { isIcon }
    },
})
</script>

<style lang="postcss" scoped>
.router-link-active {
    @apply bg-brand-500 text-brand-500 bg-opacity-25;
}
.router-link-active span {
    @apply text-brand-500;
}
</style>
